import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ShipmentLoadTrackingMapFacade } from './shipment-load-tracking-map.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadTrackingMapGuard {
  constructor(private shipmentLoadTrackingMapFacade: ShipmentLoadTrackingMapFacade) {}

  canActivate({ queryParams }: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    const { loadNumber, region } = queryParams;
    return checkStoreState(this.shipmentLoadTrackingMapFacade, { loadNumber, region });
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentLoadTrackingMapFacade);
  }
}
